//
// locales/vanilla/sq.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/sq.json';
import localeData from 'react-intl/locale-data/sq.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
